import { analytics } from "../index.mjs";
const tutorial = {
  /** Track a `TutorialStart` event. */
  TutorialStart(payload) {
    analytics.pushEvent("TutorialStart", payload);
  },
  /** Track a `TutorialFinish` event. */
  TutorialFinish(payload) {
    analytics.pushEvent("TutorialFinish", payload);
  },
  /** Track a `TutorialStepStart` event. */
  TutorialStepStart(payload) {
    const { stepIndex, stepName, ...rest } = payload;
    analytics.pushEvent("TutorialStepStart", {
      ...rest,
      $stepIndex: stepIndex,
      // Prefix with `$` to maintain compatibility with existing event properties
      $stepName: stepName
    });
  },
  /** Track a `TutorialStepFinish` event. */
  TutorialStepFinish(payload) {
    const { stepElapsedSeconds, stepIndex, stepName, ...rest } = payload;
    analytics.pushEvent("TutorialStepFinish", {
      ...rest,
      $stepElapsedSeconds: stepElapsedSeconds,
      $stepIndex: stepIndex,
      $stepName: stepName
    });
  }
};
export {
  tutorial
};
